export default "__VITE_ASSET__80794129__"